export default function Pentagon({ className = '' }: { className?: string }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="173" height="150" fill="none" viewBox="0 0 173 150" className={className}>
      <path fill="#5ACD8F" d="M129.75 150h-86.5L0 75 43.25 0h86.5L173 75l-43.25 75z"></path>
    </svg>
  )
}
